import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CheckoutFacade } from '@checkout/data-access';
import {
  CheckoutRoutes,
  CmsMarketingPreferencesPage,
  MarketingPreferencesFormValue,
} from '@checkout/util-models';
import { BasketFacade, QuoteDetails } from '@domgen/dgx-fe-basket';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { CustomerMarketingPreferenceDetails } from '@domgen/dgx-fe-common';
import { Observable, combineLatest } from 'rxjs';
import { formatMarketingPreferenceDetails } from '../../utils/marketing-preferences-form/marketing-preferences-form.utils';

export interface ViewModel {
  cmsData: CmsMarketingPreferencesPage;
  selectedQuotes?: QuoteDetails[];
}

@Injectable()
export class MarketingPreferencesComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
    selectedQuotes: this.basketFacade.selectedQuotes$,
  });

  constructor(
    private readonly basketFacade: BasketFacade,
    private readonly checkoutFacade: CheckoutFacade,
    private readonly cmsContainer: CmsContainer<CmsMarketingPreferencesPage>,
    private readonly router: Router
  ) {}

  onFormSubmit(formValue: MarketingPreferencesFormValue): void {
    const marketingPreferences: CustomerMarketingPreferenceDetails =
      formatMarketingPreferenceDetails(formValue);

    this.checkoutFacade.upsertCustomerMarketingPreferenceDetails(
      marketingPreferences
    );
    this.continueToNextStep();
  }

  private continueToNextStep(): void {
    this.router.navigateByUrl(CheckoutRoutes.PaymentMethod);
  }
}
